import { render } from "./template.vue?vue&type=template&id=4f2db5d8&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"

import "./template.vue?vue&type=style&index=0&id=4f2db5d8&scoped=true&lang=css"
import "./template.vue?vue&type=style&index=1&id=4f2db5d8&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2db5d8"]])

export default __exports__